const mockServiceCompleteReferralData = [
    {
        "id": 10818,
        "organization_id": 6972,
        "location_id": 6973,
        "source_service_id": 8828,
        "source_id_programAtSite": 78193239,
        "source_id_program": 78149584,
        "source": "icarol",
        "program_id": null,
        "program": null,
        "name": "WEATHERIZATION PROGRAMS",
        "alternate_name": null,
        "description": "Provides safe, energy conservation services. Weather stripping, caulking, insulation in walls, attics, and crawl spaces.",
        "url": "www.communityactionam.org",
        "email": "frontdesk@communityactionam.org",
        "status": 1,
        "interpretation_services": null,
        "application_process": "Contact office for an application",
        "wait_time": null,
        "fees": "Fees vary",
        "schedule_notes": "Mon-Fri 8am-4:30pm",
        "accreditations": null,
        "licenses": null,
        "eligibility": "- Family annual gross income below 200% of poverty level  - No serious roofing or structural problems",
        "language": null,
        "payment_accepted": null,
        "required_document": "Verification of household income and home ownership",
        "service_area": "Alger and Marquette counties",
        "area_served_description": "Alger and Marquette counties",
        "region": "UPER",
        "contacts": [
            {
                "id": "212083",
                "name": "Michelle LaJoie",
                "email": "mlajoie@communityactionam.org",
                "title": "Executive Director",
                "hasPhone": "1",
                "department": "",
                "service_id": "",
                "location_id": "",
                "organization_id": "",
                "source_service_id": "8828",
                "service_at_location_id": ""
            }
        ],
        "regular_schedule": [
            {
                "id": "1219761",
                "weekday": "",
                "opens_at": "",
                "closes_at": "",
                "service_id": "",
                "site_hours": "",
                "service_hours": "Mon-Fri 8am-4:30pm",
                "organization_id": "",
                "source_service_id": "8828",
                "administrative_hours": "",
                "service_at_location_id": ""
            }
        ],
        "schedule": [],
        "phones": [
            {
                "id": "2161725",
                "type": "Intake",
                "number": "9062286522",
                "language": "",
                "extension": "208",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "8828",
                "phone_type_hierarchy": "4",
                "service_at_location_id": ""
            },
            {
                "id": "2161726",
                "type": "Main",
                "number": "9062286522",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "8828",
                "phone_type_hierarchy": "1",
                "service_at_location_id": ""
            }
        ],
        "service_taxonomy": [
            {
                "id": "1307907",
                "category": "",
                "subcategory": "",
                "taxonomy_id": "BH-3000.1800-950",
                "taxonomy_detail": "Weatherization Programs",
                "source_service_id": "8828"
            }
        ],
        "physical_address": [
            {
                "id": "17674",
                "city": "Marquette",
                "county": "Marquette",
                "region": "UPER",
                "country": "United States",
                "address_1": "1125 Commerce Drive",
                "address_2": "",
                "address_3": "",
                "address_4": "",
                "attention": "",
                "is_physical": "1",
                "location_id": "6973",
                "postal_code": "49855",
                "state_province": "MI",
                "organization_id": ""
            }
        ],
        "locations": [
            {
                "id": "6973",
                "url": "www.communityactionam.org",
                "name": "COMMUNITY ACTION ALGER-MARQUETTE - MAIN OFFICE",
                "source": "icarol",
                "latitude": "46.5500000",
                "longitude": "87.4000000",
                "source_id": "78183134",
                "description": "",
                "alternate_name": "AMCAB,ALGER-MARQUETTE COMMUNITY ACTION BOARD",
                "schedule_notes": "Mon-Fri 8am-4:30pm",
                "transportation": "Public transportation available",
                "organization_id": "6972",
                "organization_name": "COMMUNITY ACTION ALGER-MARQUETTE",
                "accessibility_for_disabilities": "Accessible Parking,Wheelchair Accessible Service Area"
            }
        ],
        "service_area_served": [
            {
                "id": "127788",
                "name": "Alger",
                "type": "county",
                "service_id": "",
                "source_service_id": "8828"
            },
            {
                "id": "127789",
                "name": "Marquette",
                "type": "county",
                "service_id": "",
                "source_service_id": "8828"
            }
        ],
        "tags": [
            {
                "erp": "",
                "category": "UPPCO",
                "description": "",
                "subcategory": "",
                "tag_answers": [
                    {
                        "answer": "1",
                        "question": "Accepts referrals through MI211 Integration Partner",
                        "answer_data_type": "boolean",
                        "classification_question_id": "8",
                        "classification_reference_id": "33",
                        "classification_reference_answer_id": "32"
                    },
                    {
                        "answer": "0",
                        "question": "Accepts iCarol electronic referral partner (ERP)",
                        "answer_data_type": "boolean",
                        "classification_question_id": "9",
                        "classification_reference_id": "33",
                        "classification_reference_answer_id": "33"
                    },
                    {
                        "answer": "amandaw@brightstreetgroup.com",
                        "question": "Organization referral email",
                        "answer_data_type": "string",
                        "classification_question_id": "12",
                        "classification_reference_id": "33",
                        "classification_reference_answer_id": "31"
                    }
                ]
            }
        ]
    },
    {
        "id": 12452,
        "organization_id": 8589,
        "location_id": 8601,
        "source_service_id": 10482,
        "source_id_programAtSite": 78210540,
        "source_id_program": 78169262,
        "source": "icarol",
        "program_id": null,
        "program": null,
        "name": "UTILITY SERVICE PAYMENT ASSISTANCE",
        "alternate_name": null,
        "description": "Provides assistance in the form of a voucher to individuals and families in an emergency situation. Financial requests are generally not approved at the time of request; allow for one week for decision.",
        "url": "www.svdmqtdistrict.org",
        "email": "svdp@svdpup.org",
        "status": 1,
        "interpretation_services": null,
        "application_process": "Call for information or Walk-in",
        "wait_time": null,
        "fees": "No fees",
        "schedule_notes": "Mon, Wed, Fri 1pm-4pm",
        "accreditations": null,
        "licenses": null,
        "eligibility": "Low income or unexpected emergency",
        "language": null,
        "payment_accepted": "Not applicable",
        "required_document": "Rental agreement, utility bill or other documentation showing need is required.",
        "service_area": "Marquette County",
        "area_served_description": "Marquette County",
        "region": "UPER",
        "contacts": [],
        "regular_schedule": [
            {
                "id": "1241595",
                "weekday": "",
                "opens_at": "",
                "closes_at": "",
                "service_id": "12452",
                "site_hours": "",
                "service_hours": "Mon, Wed, Fri 1pm-4pm",
                "organization_id": "",
                "source_service_id": "",
                "administrative_hours": "",
                "service_at_location_id": ""
            }
        ],
        "schedule": [],
        "phones": [
            {
                "id": "2176389",
                "type": "Main",
                "number": "9062263840",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "12452",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "",
                "phone_type_hierarchy": "1",
                "service_at_location_id": ""
            }
        ],
        "service_taxonomy": [
            {
                "id": "1349015",
                "category": "Utilities",
                "subcategory": "Electric Service Payment Assistance",
                "taxonomy_id": "BV-8900.9300-180",
                "taxonomy_detail": "Electric Service Payment Assistance",
                "source_service_id": "10482"
            },
            {
                "id": "1349016",
                "category": "Utilities",
                "subcategory": "Gas Service Payment Assistance",
                "taxonomy_id": "BV-8900.9300-250",
                "taxonomy_detail": "Gas Service Payment Assistance",
                "source_service_id": "10482"
            },
            {
                "id": "1349017",
                "category": "Utilities",
                "subcategory": "Heating Fuel Payment Assistance",
                "taxonomy_id": "BV-8900.9300-300",
                "taxonomy_detail": "Heating Fuel Payment Assistance",
                "source_service_id": "10482"
            },
            {
                "id": "1349018",
                "category": "Utilities",
                "subcategory": "Water Service Payment Assistance",
                "taxonomy_id": "BV-8900.9300-950",
                "taxonomy_detail": "Water Service Payment Assistance",
                "source_service_id": "10482"
            }
        ],
        "physical_address": [
            {
                "id": "18377",
                "city": "Marquette",
                "county": "Marquette",
                "region": "UPER",
                "country": "United States",
                "address_1": "2119 Presque Isle",
                "address_2": "",
                "address_3": "",
                "address_4": "",
                "attention": "",
                "is_physical": "1",
                "location_id": "8601",
                "postal_code": "49855",
                "state_province": "MI",
                "organization_id": ""
            }
        ],
        "locations": [
            {
                "id": "8601",
                "url": "www.svdmqtdistrict.org",
                "name": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE - MARQUETTE",
                "source": "icarol",
                "latitude": "46.5500000",
                "longitude": "87.4000000",
                "source_id": "78175424",
                "description": "",
                "alternate_name": "ST VINCENT DE PAUL SOCIETY,ST VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE,ST. VINCENT DE PAUL SOCIETY,ST. VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                "schedule_notes": "",
                "transportation": "No public transportation available",
                "organization_id": "8589",
                "organization_name": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                "accessibility_for_disabilities": "Accessible Restroom,Accessible Parking,No Step Entrance,Wheelchair Accessible Service Area"
            }
        ],
        "service_area_served": [
            {
                "id": "189042",
                "name": "Big Bay",
                "type": "city",
                "service_id": "12452",
                "source_service_id": ""
            },
            {
                "id": "189044",
                "name": "Gwinn",
                "type": "city",
                "service_id": "12452",
                "source_service_id": ""
            },
            {
                "id": "189043",
                "name": "Harvey",
                "type": "city",
                "service_id": "12452",
                "source_service_id": ""
            },
            {
                "id": "189038",
                "name": "Marquette-Alger",
                "type": "city",
                "service_id": "12452",
                "source_service_id": ""
            },
            {
                "id": "189039",
                "name": "Marquette-Marquette",
                "type": "city",
                "service_id": "12452",
                "source_service_id": ""
            },
            {
                "id": "189040",
                "name": "Skandia-Alger",
                "type": "city",
                "service_id": "12452",
                "source_service_id": ""
            },
            {
                "id": "189041",
                "name": "Skandia-Marquette",
                "type": "city",
                "service_id": "12452",
                "source_service_id": ""
            }
        ],
        "tags": []
    },
    {
        "id": 121184,
        "organization_id": 39284,
        "location_id": 39287,
        "source_service_id": 48428,
        "source_id_programAtSite": 78208850,
        "source_id_program": 78152212,
        "source": "icarol",
        "program_id": null,
        "program": "HOME HEATING CREDIT",
        "name": "UTILITY TAX EXEMPTION INFORMATION",
        "alternate_name": null,
        "description": "Provides forms to apply for  Home Heating Credit. The credit is available to low income families to assist with the cost of heating their homes and is based on income, exemptions claimed, and annual heating costs. Payment is made directly to the heat provider.",
        "url": "https://www.michigan.gov/taxes/questions/iit/accordion/heating/home-heating-credit-information-1",
        "email": "MIStatetreasurer@michigan.gov",
        "status": 1,
        "interpretation_services": null,
        "application_process": "Complete the Michigan Home Heating Credit Claim. Form is available online, at all office of the Michigan Department of Treasury, Michigan Secretary of State branch offices, Michigan Department of Human Services branch offices and many public libraries. Assistance completing the form is available during tax season at AARP Tax Aide Program sites and at VITA Program Sites. Tax preparers are not able complete the Home Heating Credit Claim over the phone    *Application must be submitted no later than September 30, 2024 to receive credit.    ** Status of Home Heating Credit draft may be available 4 weeks after filing; visit: https://www.michigan.gov/taxes/questions/iit/accordion/heating/what-should-i-do-if-my-home-heating-credit-has-been-processed and follow steps to check status",
        "wait_time": null,
        "fees": "- No fee to file   - Most claimants receive an energy draft to use as payment toward current and future heating bills which must be given to the energy provider before the expiration date on the draft.    - The energy draft can only be used to pay heating bills in the claimant's name and may not be cashed  - Claimants who are enrolled with the Department of Human Services will typically have their credit sent directly to their heat provider",
        "schedule_notes": "The deadline for filing a  home heating credit is September 30, 2024",
        "accreditations": null,
        "licenses": null,
        "eligibility": "- Home must be in Michigan and must be owned or rented- Income requirements apply based on the number of tax exemptions in the household- Cannot be a full time student or be claimed as a dependent on another person's income tax return",
        "language": null,
        "payment_accepted": "Not applicable",
        "required_document": "Proof of income, including yearly DHHS benefit amounts, SSI/SSA benefit amounts for filer and all dependents, child support, unemployment benefits, and total amount received as cash gifts over $300 or expenses paid on filer's behalf by friends and family for the year; a copy of utility bills for the period of December through March verifying heating costs and the number of exemptions claimed. https://www.michigan.gov/taxes/-/media/Project/Websites/taxes/HHC_Checklist_1-2020_pdf_2/11/2021_715987.pdf",
        "service_area": "Michigan",
        "area_served_description": "Michigan",
        "region": "MICH",
        "contacts": [],
        "regular_schedule": [
            {
                "id": "1247136",
                "weekday": "",
                "opens_at": "",
                "closes_at": "",
                "service_id": "",
                "site_hours": "",
                "service_hours": "The deadline for filing a  home heating credit is September 30, 2024",
                "organization_id": "",
                "source_service_id": "48428",
                "administrative_hours": "",
                "service_at_location_id": ""
            }
        ],
        "schedule": [],
        "phones": [
            {
                "id": "2185431",
                "type": "Main",
                "number": "5173357508",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "48428",
                "phone_type_hierarchy": "1",
                "service_at_location_id": ""
            }
        ],
        "service_taxonomy": [
            {
                "id": "1347874",
                "category": "",
                "subcategory": "",
                "taxonomy_id": "DT-8700.9000",
                "taxonomy_detail": "Utility Tax Exemption Information",
                "source_service_id": "48428"
            }
        ],
        "physical_address": [],
        "locations": [
            {
                "id": "39287",
                "url": "www.michigan.gov/treasury",
                "name": "MICHIGAN DEPARTMENT OF TREASURY",
                "source": "icarol",
                "latitude": "",
                "longitude": "",
                "source_id": "78185526",
                "description": "",
                "alternate_name": "MICHIGAN TREASURY",
                "schedule_notes": "Mon-Fri 8am-4:45pm excluding state holidays",
                "transportation": "No public transportation available",
                "organization_id": "39284",
                "organization_name": "MICHIGAN DEPARTMENT OF TREASURY",
                "accessibility_for_disabilities": ""
            }
        ],
        "service_area_served": [
            {
                "id": "221321",
                "name": "Michigan",
                "type": "state",
                "service_id": "",
                "source_service_id": "48428"
            }
        ],
        "tags": [
            {
                "erp": "",
                "category": "UPPCO",
                "description": "",
                "subcategory": "",
                "tag_answers": [
                    {
                        "answer": "1",
                        "question": "Accepts referrals through MI211 Integration Partner",
                        "answer_data_type": "boolean",
                        "classification_question_id": "8",
                        "classification_reference_id": "33",
                        "classification_reference_answer_id": "32"
                    },
                    {
                        "answer": "0",
                        "question": "Accepts iCarol electronic referral partner (ERP)",
                        "answer_data_type": "boolean",
                        "classification_question_id": "9",
                        "classification_reference_id": "33",
                        "classification_reference_answer_id": "33"
                    },
                    {
                        "answer": "amandaw@brightstreetgroup.com",
                        "question": "Organization referral email",
                        "answer_data_type": "string",
                        "classification_question_id": "12",
                        "classification_reference_id": "33",
                        "classification_reference_answer_id": "31"
                    }
                ]
            }
        ]
    },
    {
        "id": 154800,
        "organization_id": 46302,
        "location_id": 46670,
        "source_service_id": 60651,
        "source_id_programAtSite": 78218508,
        "source_id_program": 78169059,
        "source": "icarol",
        "program_id": null,
        "program": "MICHIGAN ENERGY ASSISTANCE PROGRAM (MEAP)",
        "name": "UTILITY SERVICE PAYMENT ASSISTANCE (2023-2024)(MEAP)",
        "alternate_name": "MEAP  ONE-TIME ASSIST",
        "description": "Provides one-time payment assistance and self-sufficiency supports for those needing utility assistance.",
        "url": "https://superiorwatersheds.org/energy-conservation",
        "email": "meap@superiorwatersheds.org",
        "status": 1,
        "interpretation_services": null,
        "application_process": "- Apply through MIBridges/DHHS for SER (State Emergency Relief)  - After submitting SER application, select/choose [name of agency] as the 'MEAP grantee/Community Partner Agency'  - Call for additional information/instruction (or for assistance in completing the SER application process within MIBridges)",
        "wait_time": null,
        "fees": "No fees",
        "schedule_notes": "Mon-Fri 8am-5pm",
        "accreditations": null,
        "licenses": null,
        "eligibility": "- Must have a past due balance or shut-off notice (or propane tank at or below 25%)  - Must have applied for and received approval through DHHS for SER (State Emergency Relief) assistance or Superior Watershed will assist with application  - Must meet the household income guidelines at or below 150% FPL",
        "language": null,
        "payment_accepted": "Not applicable",
        "required_document": "- DHHS approval for SER  - Other documentation as requested by agency",
        "service_area": "Alger, Baraga, Chippewa, Delta, Dickinson, Gogebic, Houghton, Iron, Keweenaw, Luce, Mackinac, Marquette, Menominee, Ontonagon and Schoolcraft counties",
        "area_served_description": "Alger, Baraga, Chippewa, Delta, Dickinson, Gogebic, Houghton, Iron, Keweenaw, Luce, Mackinac, Marquette, Menominee, Ontonagon and Schoolcraft counties",
        "region": "UPER",
        "contacts": [],
        "regular_schedule": [
            {
                "id": "1248700",
                "weekday": "",
                "opens_at": "",
                "closes_at": "",
                "service_id": "",
                "site_hours": "",
                "service_hours": "Mon-Fri 8am-5pm",
                "organization_id": "",
                "source_service_id": "60651",
                "administrative_hours": "",
                "service_at_location_id": ""
            }
        ],
        "schedule": [],
        "phones": [
            {
                "id": "2188336",
                "type": "Main",
                "number": "9062732742",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "60651",
                "phone_type_hierarchy": "1",
                "service_at_location_id": ""
            }
        ],
        "service_taxonomy": [
            {
                "id": "1348934",
                "category": "Utilities",
                "subcategory": "Electric Service Payment Assistance",
                "taxonomy_id": "BV-8900.9300-180",
                "taxonomy_detail": "Electric Service Payment Assistance",
                "source_service_id": "60651"
            },
            {
                "id": "1348935",
                "category": "Utilities",
                "subcategory": "Gas Service Payment Assistance",
                "taxonomy_id": "BV-8900.9300-250",
                "taxonomy_detail": "Gas Service Payment Assistance",
                "source_service_id": "60651"
            },
            {
                "id": "1348936",
                "category": "Utilities",
                "subcategory": "Heating Fuel Payment Assistance",
                "taxonomy_id": "BV-8900.9300-300",
                "taxonomy_detail": "Heating Fuel Payment Assistance",
                "source_service_id": "60651"
            }
        ],
        "physical_address": [
            {
                "id": "17545",
                "city": "Marquette",
                "county": "Marquette",
                "region": "UPER",
                "country": "United States",
                "address_1": "1104 North 3rd Street",
                "address_2": "",
                "address_3": "",
                "address_4": "",
                "attention": "",
                "is_physical": "1",
                "location_id": "46670",
                "postal_code": "49855",
                "state_province": "MI",
                "organization_id": ""
            }
        ],
        "locations": [
            {
                "id": "46670",
                "url": "www.superiorwatersheds.org",
                "name": "SUPERIOR WATERSHED PARTNERSHIP",
                "source": "icarol",
                "latitude": "46.5565700",
                "longitude": "87.3884700",
                "source_id": "78186426",
                "description": "",
                "alternate_name": "",
                "schedule_notes": "Mon-Fri 8am-5pm",
                "transportation": "Public transportation available",
                "organization_id": "46302",
                "organization_name": "SUPERIOR WATERSHED PARTNERSHIP",
                "accessibility_for_disabilities": ""
            }
        ],
        "service_area_served": [
            {
                "id": "223804",
                "name": "Alger",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223805",
                "name": "Baraga",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223806",
                "name": "Chippewa",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223807",
                "name": "Delta",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223808",
                "name": "Dickinson",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223809",
                "name": "Gogebic",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223810",
                "name": "Houghton",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223811",
                "name": "Iron",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223812",
                "name": "Keweenaw",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223813",
                "name": "Luce",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223814",
                "name": "Mackinac",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223815",
                "name": "Marquette",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223816",
                "name": "Menominee",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223817",
                "name": "Ontonagon",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            },
            {
                "id": "223818",
                "name": "Schoolcraft",
                "type": "county",
                "service_id": "",
                "source_service_id": "60651"
            }
        ],
        "tags": []
    },
    {
        "id": 157628,
        "organization_id": 47242,
        "location_id": 47243,
        "source_service_id": 61575,
        "source_id_programAtSite": 78206011,
        "source_id_program": 78152203,
        "source": "icarol",
        "program_id": null,
        "program": "MEDICAL EMERGENCY PROTECTION",
        "name": "UTILITY DISCONNECTION PROTECTION (MEDICAL PROTECTION)",
        "alternate_name": "MEDICAL EMERGENCY PROTECTION",
        "description": "Offers information on how a customer may provide a signed medical certification hold request or critical care shutoff protection to postpone the discontinuance of utility service or restore utility service. - Critical Care Protection: A customer or household can receive protection from disconnection or have services restored due to inability to pay if there is an identified critical care customer in the home and interruption of service would be immediately life-threatening due to requirement of home medical equipment or a life support system. The Medical Certification form must be certified by a physician or public health official and updated on an annual basis. - Medical Emergency Protection: A customer requires or has a household member that has a medical condition that would be aggravated by lack of utility service or requires home medical equipment, as defined and certified by a physician or public health official. If a customer submits an approved medical emergency hold request,  Upper Peninsula Power Company will suspend shut-off action for 21 days or services will be restored, where applicable. The customer may be charged a deposit or restoration fees to the account for service restoration due to disconnection for non-payment.-",
        "url": "https://www.uppco.com/residential/help-with-your-energy-bill/#shutoff-protection",
        "email": "customerservice@uppco.com",
        "status": 1,
        "interpretation_services": null,
        "application_process": "Call for form or download form: https://www.uppco.com/wp-content/uploads/2019/03/Medical_Certification_Form.pdf",
        "wait_time": null,
        "fees": "No fees to apply",
        "schedule_notes": "Mon-Fri 8am-5pm",
        "accreditations": null,
        "licenses": null,
        "eligibility": "Customer requires, or has a household member that requires, home medical equipment, a life support system, or a medical emergency as defined by a physician or public health official",
        "language": null,
        "payment_accepted": "Not applicable",
        "required_document": "- Completed form (by customer/patient and physician)  - Government issued photo identification (as requested)",
        "service_area": "Alger, Baraga, Delta, Houghton, Iron, Keweenaw, Marquette Menominee, Ontonagon and Schoolcraft counties",
        "area_served_description": "Alger, Baraga, Delta, Houghton, Iron, Keweenaw, Marquette Menominee, Ontonagon and Schoolcraft counties",
        "region": "UPER",
        "contacts": [],
        "regular_schedule": [
            {
                "id": "1249368",
                "weekday": "",
                "opens_at": "",
                "closes_at": "",
                "service_id": "",
                "site_hours": "",
                "service_hours": "Mon-Fri 8am-5pm",
                "organization_id": "",
                "source_service_id": "61575",
                "administrative_hours": "",
                "service_at_location_id": ""
            }
        ],
        "schedule": [],
        "phones": [
            {
                "id": "2189415",
                "type": "Main",
                "number": "9064492013",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "61575",
                "phone_type_hierarchy": "1",
                "service_at_location_id": ""
            }
        ],
        "service_taxonomy": [
            {
                "id": "1349608",
                "category": "",
                "subcategory": "",
                "taxonomy_id": "BV-8900.9220",
                "taxonomy_detail": "Utility Disconnection Protection",
                "source_service_id": "61575"
            }
        ],
        "physical_address": [
            {
                "id": "17561",
                "city": "Ishpeming",
                "county": "Marquette",
                "region": "UPER",
                "country": "United States",
                "address_1": "500 North Washington Street",
                "address_2": "",
                "address_3": "",
                "address_4": "",
                "attention": "",
                "is_physical": "1",
                "location_id": "47243",
                "postal_code": "49849",
                "state_province": "MI",
                "organization_id": ""
            }
        ],
        "locations": [
            {
                "id": "47243",
                "url": "www.uppco.com",
                "name": "UPPER PENINSULA POWER COMPANY",
                "source": "icarol",
                "latitude": "46.4940000",
                "longitude": "87.6653700",
                "source_id": "78174624",
                "description": "",
                "alternate_name": "UP POWER, UPPCO",
                "schedule_notes": "Mon-Fri 8am-5pm",
                "transportation": "No public transportation available",
                "organization_id": "47242",
                "organization_name": "UPPER PENINSULA POWER COMPANY",
                "accessibility_for_disabilities": ""
            }
        ],
        "service_area_served": [
            {
                "id": "225329",
                "name": "Alger",
                "type": "county",
                "service_id": "",
                "source_service_id": "61575"
            },
            {
                "id": "225330",
                "name": "Baraga",
                "type": "county",
                "service_id": "",
                "source_service_id": "61575"
            },
            {
                "id": "225331",
                "name": "Delta",
                "type": "county",
                "service_id": "",
                "source_service_id": "61575"
            },
            {
                "id": "225332",
                "name": "Houghton",
                "type": "county",
                "service_id": "",
                "source_service_id": "61575"
            },
            {
                "id": "225333",
                "name": "Iron",
                "type": "county",
                "service_id": "",
                "source_service_id": "61575"
            },
            {
                "id": "225334",
                "name": "Keweenaw",
                "type": "county",
                "service_id": "",
                "source_service_id": "61575"
            },
            {
                "id": "225335",
                "name": "Marquette",
                "type": "county",
                "service_id": "",
                "source_service_id": "61575"
            },
            {
                "id": "225337",
                "name": "Menominee",
                "type": "county",
                "service_id": "",
                "source_service_id": "61575"
            },
            {
                "id": "225336",
                "name": "Ontonagon",
                "type": "county",
                "service_id": "",
                "source_service_id": "61575"
            },
            {
                "id": "225338",
                "name": "Schoolcraft",
                "type": "county",
                "service_id": "",
                "source_service_id": "61575"
            }
        ],
        "tags": []
    },
    {
        "id": 157630,
        "organization_id": 47242,
        "location_id": 47243,
        "source_service_id": 61577,
        "source_id_programAtSite": 78206066,
        "source_id_program": 78152243,
        "source": "icarol",
        "program_id": null,
        "program": "ENERGY STAR PRODUCT REBATES",
        "name": "RESIDENTIAL ENERGY/WATER CONSERVATION REBATES",
        "alternate_name": null,
        "description": "Provides rebates to residential customers who purchase qualifying energy Energy Star efficient appliances.Rebate Amounts:- Energy Star chest freezer, upright freezer, refrigerator/freezer/$15- Dishwasher/$15- Air Purifier/$25- Portable Dehumidifier/$25- Continuous Bathroom Exhaust Fan/$15- Electric Clothes Washer/$25- Electric Clothes Dryer/$25- Heat Pump Clothes Dryer/$50- Ceiling Fan/$10- Room Air Conditioner/$25- Television/$25- Heat Pump Water Heaters/$350-$600- LED lighting/$1.50-$2.50",
        "url": "www.uppco.com",
        "email": "customerservice@uppco.com",
        "status": 1,
        "interpretation_services": null,
        "application_process": "Call for an application or go online to: https://ee.uppco.com/Energy-Star",
        "wait_time": null,
        "fees": "No fees",
        "schedule_notes": null,
        "accreditations": null,
        "licenses": null,
        "eligibility": "Call or visit website for more information",
        "language": null,
        "payment_accepted": "Not applicable",
        "required_document": "- A copy of your sales receipt/invoice indicating equipment type, manufacturer, model number, purchase/installation date and price  - Your utility account number and a copy of most recent bill  - Installing contractor information, if applicable",
        "service_area": "Alger, Baraga, Delta, Houghton, Iron, Keweenaw, Marquette, Menominee, Ontonagon and Schoolcraft counties",
        "area_served_description": "Alger, Baraga, Delta, Houghton, Iron, Keweenaw, Marquette, Menominee, Ontonagon and Schoolcraft counties",
        "region": "UPER",
        "contacts": [],
        "regular_schedule": [],
        "schedule": [],
        
        "phones": [
            {
                "id": "2184971",
                "type": "Main",
                "number": "9064492222",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "61577",
                "phone_type_hierarchy": "1",
                "service_at_location_id": ""
            }
        ],
        "service_taxonomy": [
            {
                "id": "1347545",
                "category": "",
                "subcategory": "",
                "taxonomy_id": "BH-3000.1800-700",
                "taxonomy_detail": "Residential Energy/Water Conservation Rebates",
                "source_service_id": "61577"
            }
        ],
        "physical_address": [
            {
                "id": "17561",
                "city": "Ishpeming",
                "county": "Marquette",
                "region": "UPER",
                "country": "United States",
                "address_1": "500 North Washington Street",
                "address_2": "",
                "address_3": "",
                "address_4": "",
                "attention": "",
                "is_physical": "1",
                "location_id": "47243",
                "postal_code": "49849",
                "state_province": "MI",
                "organization_id": ""
            }
        ],
        "locations": [
            {
                "id": "47243",
                "url": "www.uppco.com",
                "name": "UPPER PENINSULA POWER COMPANY",
                "source": "icarol",
                "latitude": "46.4940000",
                "longitude": "87.6653700",
                "source_id": "78174624",
                "description": "",
                "alternate_name": "UP POWER, UPPCO",
                "schedule_notes": "Mon-Fri 8am-5pm",
                "transportation": "No public transportation available",
                "organization_id": "47242",
                "organization_name": "UPPER PENINSULA POWER COMPANY",
                "accessibility_for_disabilities": ""
            }
        ],
        "service_area_served": [
            {
                "id": "220614",
                "name": "Alger",
                "type": "county",
                "service_id": "",
                "source_service_id": "61577"
            },
            {
                "id": "220615",
                "name": "Baraga",
                "type": "county",
                "service_id": "",
                "source_service_id": "61577"
            },
            {
                "id": "220616",
                "name": "Delta",
                "type": "county",
                "service_id": "",
                "source_service_id": "61577"
            },
            {
                "id": "220617",
                "name": "Houghton",
                "type": "county",
                "service_id": "",
                "source_service_id": "61577"
            },
            {
                "id": "220618",
                "name": "Iron",
                "type": "county",
                "service_id": "",
                "source_service_id": "61577"
            },
            {
                "id": "220619",
                "name": "Keweenaw",
                "type": "county",
                "service_id": "",
                "source_service_id": "61577"
            },
            {
                "id": "220620",
                "name": "Marquette",
                "type": "county",
                "service_id": "",
                "source_service_id": "61577"
            },
            {
                "id": "220622",
                "name": "Menominee",
                "type": "county",
                "service_id": "",
                "source_service_id": "61577"
            },
            {
                "id": "220621",
                "name": "Ontonagon",
                "type": "county",
                "service_id": "",
                "source_service_id": "61577"
            },
            {
                "id": "220623",
                "name": "Schoolcraft",
                "type": "county",
                "service_id": "",
                "source_service_id": "61577"
            }
        ],
        "tags": []
    },
    {
        "id": 158505,
        "organization_id": 7446,
        "location_id": 7447,
        "source_service_id": 51640,
        "source_id_programAtSite": 78218070,
        "source_id_program": 78144350,
        "source": "icarol",
        "program_id": null,
        "program": "MICHIGAN VETERAN'S TRUST FUND",
        "name": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE FOR VETERANS",
        "alternate_name": null,
        "description": "Provides temporary, emergency financial assistance to Veterans and their families. Assistance may be available with automobile repair, utility bills, medical or dental expenses, emergency home repairs, or other things as approved during a hardship situation.",
        "url": "www.co.marquette.mi.us",
        "email": null,
        "status": 1,
        "interpretation_services": null,
        "application_process": "Call for more information and appointment",
        "wait_time": null,
        "fees": "No fees",
        "schedule_notes": "Wed 8am-11am",
        "accreditations": null,
        "licenses": null,
        "eligibility": "- Honorably discharged Veterans and their family members    - Veterans must have served during wartime  - Other eligibility requirements apply, call for more information",
        "language": null,
        "payment_accepted": "Not applicable",
        "required_document": "The following items are required when filing an application for trust fund assistance: discharge papers, separation report, or DD-214 (showing the dates of active duty and the character of the release); proof of residence (driver's license, state ID); and bills or account statements regarding the items for which the individual is seeking a MVTF grant. One or more of the following items may be required when filing an application for trust fund assistance: marriage certificate; birth certificates for minor children; death certificate of a deceased spouse or parent; documentation of any disability rating; proof of employment or other income; and evidence of efforts at other appropriate agencies",
        "service_area": "Marquette County",
        "area_served_description": "Marquette County",
        "region": "UPER",
        
        "contacts": [
            {
                "id": "211007",
                "name": "Rachel Woody",
                "email": "rwoody@mqtco.org",
                "title": "Veteran Service Officer",
                "hasPhone": "1",
                "department": "",
                "service_id": "",
                "location_id": "",
                "organization_id": "",
                "source_service_id": "51640",
                "service_at_location_id": ""
            }
        ],
        "regular_schedule": [
            {
                "id": "1216346",
                "weekday": "",
                "opens_at": "",
                "closes_at": "",
                "service_id": "",
                "site_hours": "",
                "service_hours": "Wed 8am-11am",
                "organization_id": "",
                "source_service_id": "51640",
                "administrative_hours": "",
                "service_at_location_id": ""
            }
        ],
        "schedule": [],
        "phones": [
            {
                "id": "2159589",
                "type": "Intake",
                "number": "9064851781",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "51640",
                "phone_type_hierarchy": "4",
                "service_at_location_id": ""
            }
        ],
        "service_taxonomy": [
            {
                "id": "1301469",
                "category": "",
                "subcategory": "",
                "taxonomy_id": "NT-8900 * YN-9000",
                "taxonomy_detail": "Undesignated Temporary Financial Assistance * Veterans",
                "source_service_id": "51640"
            }
        ],
        "physical_address": [
            {
                "id": "17859",
                "city": "Marquette",
                "county": "Marquette",
                "region": "UPER",
                "country": "United States",
                "address_1": "234 West Baraga Avenue",
                "address_2": "",
                "address_3": "",
                "address_4": "",
                "attention": "",
                "is_physical": "1",
                "location_id": "7447",
                "postal_code": "49855",
                "state_province": "MI",
                "organization_id": ""
            }
        ],
        "locations": [
            {
                "id": "7447",
                "url": "www.co.marquette.mi.us",
                "name": "MARQUETTE COUNTY GOVERNMENT - ADMINISTRATIVE OFFICE",
                "source": "icarol",
                "latitude": "46.5414773",
                "longitude": "87.3979540",
                "source_id": "78185024",
                "description": "",
                "alternate_name": "",
                "schedule_notes": "Mon-Fri 8am-5pm",
                "transportation": "No public transportation available",
                "organization_id": "7446",
                "organization_name": "MARQUETTE COUNTY GOVERNMENT",
                "accessibility_for_disabilities": "Wheelchair Accessible Service Area"
            }
        ],
        "service_area_served": [
            {
                "id": "119373",
                "name": "Marquette",
                "type": "county",
                "service_id": "",
                "source_service_id": "51640"
            }
        ],
        "tags": []
    },
    {
        "id": 174289,
        "organization_id": 50158,
        "location_id": 50159,
        "source_service_id": 67355,
        "source_id_programAtSite": 82347412,
        "source_id_program": 82347377,
        "source": "icarol",
        "program_id": null,
        "program": "WARRIOR RELIEF FUND",
        "name": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE FOR ACTIVE MILITARY AND VETERANS",
        "alternate_name": null,
        "description": "Provides monetary assistance to Active Duty Military, National Guard, Reserve, and veterans in time of crisis. Can assist with many categories of needs which are evaluated on a case-by-case basis.",
        "url": "906warriorrelieffund.org",
        "email": "rwood1956@yahoo.com",
        "status": 1,
        "interpretation_services": null,
        "application_process": "Print application from website 906warriorrelieffund.org and send by mail or email with required documents",
        "wait_time": null,
        "fees": "No Fees",
        "schedule_notes": "No Set Hours",
        "accreditations": null,
        "licenses": null,
        "eligibility": "- Active and retired military veterans including National Guard and Reserve members  - Must be for the service member; Not for deceased service member's dependents  - Please pursue State Emergency Relief through MDHHS first, when applicable, in order to   preserve funding.",
        "language": null,
        "payment_accepted": "Not applicable",
        "required_document": "- Copy of DD-214, Military Members most recent orders or Military ID   - Copy of the bills for which assistance is requested; Must include the account holder's name and the account number, as well as the creditor's name and phone number with area code - For assistance with repairs or other services, two different written estimates on company letterhead are required.  (For example, if requesting assistance with rent, a copy of your lease agreement is required, and copies of actual invoices)   - Proof of all income: Pay stubs, W2, Pension, Rental income, Last two months checking account statements, Last two months savings account statements, etc.",
        "service_area": "Alger, Baraga, Chippewa, Delta, Dickinson, Gogebic, Houghton, Iron, Keweenaw, Luce, Mackinac, Marquette, Menominee, Ontonagon, and Schoolcraft Counties",
        "area_served_description": "Alger, Baraga, Chippewa, Delta, Dickinson, Gogebic, Houghton, Iron, Keweenaw, Luce, Mackinac, Marquette, Menominee, Ontonagon, and Schoolcraft Counties",
        "region": "UPER",
        "contacts": [
            {
                "id": "210967",
                "name": "Richard Wood",
                "email": "rwood1956@yahoo.com",
                "title": "Director",
                "hasPhone": "1",
                "department": "",
                "service_id": "",
                "location_id": "",
                "organization_id": "",
                "source_service_id": "67355",
                "service_at_location_id": ""
            }
        ],
        "regular_schedule": [
            {
                "id": "1216129",
                "weekday": "",
                "opens_at": "",
                "closes_at": "",
                "service_id": "",
                "site_hours": "",
                "service_hours": "No Set Hours",
                "organization_id": "",
                "source_service_id": "67355",
                "administrative_hours": "",
                "service_at_location_id": ""
            }
        ],
        "schedule": [],
        "phones": [
            {
                "id": "2159488",
                "type": "Intake",
                "number": "9063467302",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "67355",
                "phone_type_hierarchy": "4",
                "service_at_location_id": ""
            },
            {
                "id": "2159489",
                "type": "Main",
                "number": "9063467302",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "67355",
                "phone_type_hierarchy": "1",
                "service_at_location_id": ""
            }
        ],
        "service_taxonomy": [
            {
                "id": "1301124",
                "category": "",
                "subcategory": "",
                "taxonomy_id": "NT-8900 * YN-9000",
                "taxonomy_detail": "Undesignated Temporary Financial Assistance * Veterans",
                "source_service_id": "67355"
            }
        ],
        "physical_address": [
            {
                "id": "32123",
                "city": "Little Lake",
                "county": "Marquette",
                "region": "UPER",
                "country": "United States",
                "address_1": "No Physical Address",
                "address_2": "",
                "address_3": "",
                "address_4": "",
                "attention": "",
                "is_physical": "1",
                "location_id": "50159",
                "postal_code": "49833",
                "state_province": "MI",
                "organization_id": ""
            }
        ],
        "locations": [
            {
                "id": "50159",
                "url": "906warriorrelieffund.org",
                "name": "906 WARRIOR RELIEF FUND",
                "source": "icarol",
                "latitude": "46.1091700",
                "longitude": "87.4393600",
                "source_id": "82347361",
                "description": "",
                "alternate_name": "",
                "schedule_notes": "No Set Hours",
                "transportation": "",
                "organization_id": "50158",
                "organization_name": "906 WARRIOR RELIEF FUND",
                "accessibility_for_disabilities": "Not Applicable"
            }
        ],
        "service_area_served": [
            {
                "id": "118906",
                "name": "Alger",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118907",
                "name": "Baraga",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118908",
                "name": "Chippewa",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118909",
                "name": "Delta",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118910",
                "name": "Dickinson",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118911",
                "name": "Gogebic",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118912",
                "name": "Houghton",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118913",
                "name": "Iron",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118915",
                "name": "Keweenaw",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118914",
                "name": "Luce",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118916",
                "name": "Mackinac",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118919",
                "name": "Marquette",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118917",
                "name": "Menominee",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118918",
                "name": "Ontonagon",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            },
            {
                "id": "118920",
                "name": "Schoolcraft",
                "type": "county",
                "service_id": "",
                "source_service_id": "67355"
            }
        ],
        "tags": []
    },
    {
        "id": 175320,
        "organization_id": 42624,
        "location_id": 42625,
        "source_service_id": 69241,
        "source_id_programAtSite": 84922329,
        "source_id_program": 84922133,
        "source": "icarol",
        "program_id": null,
        "program": "MICHIGAN VETERANS TRUST FUND",
        "name": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE FOR VETERANS",
        "alternate_name": null,
        "description": "Provides temporary, emergency financial assistance to veterans and their families. Assistance may be available to help with rent, rental deposit, utility bills, food, medical or dental expenses, bed bug treatment, emergency home repairs, or other things as approved during a hardship situation.",
        "url": "www.co.marquette.mi.us/departments/department_of_veterans_affairs",
        "email": "rwoody@mqtco.org",
        "status": 1,
        "interpretation_services": null,
        "application_process": "Call for more information and appointment",
        "wait_time": null,
        "fees": "No fees",
        "schedule_notes": null,
        "accreditations": null,
        "licenses": null,
        "eligibility": "- Honorably discharged Veterans and their family members    - Veterans 65+ who served during peacetime  - Other eligibility requirements apply, call for more information",
        "language": null,
        "payment_accepted": "Not applicable",
        "required_document": "The following items are required when filing an application for trust fund assistance:     - Discharge papers, separation report, or DD-214 (showing the dates of active duty and the character of the release)    - Proof of residence (driver's license, state ID)    - Bills or account statements regarding the items for which the individual is seeking a MVTF grant  One or more of the following items may be required when filing an application for trust fund assistance:    - Marriage certificate; birth certificates for minor children; death certificate of a deceased spouse or parent; documentation of any disability rating; proof of employment or other income; and must show evidence of efforts at other appropriate agencies.",
        "service_area": "Marquette County",
        "area_served_description": "Marquette County",
        "region": "UPER",
        "contacts": [],
        "regular_schedule": [],
        "schedule": [],
        
        "phones": [
            {
                "id": "2189398",
                "type": "Main",
                "number": "9064851996",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "69241",
                "phone_type_hierarchy": "1",
                "service_at_location_id": ""
            }
        ],
        "service_taxonomy": [
            {
                "id": "1349583",
                "category": "",
                "subcategory": "",
                "taxonomy_id": "NT-8900 * YN-9000",
                "taxonomy_detail": "Undesignated Temporary Financial Assistance * Veterans",
                "source_service_id": "69241"
            }
        ],
        "physical_address": [
            {
                "id": "17489",
                "city": "Ishpeming",
                "county": "Marquette",
                "region": "UPER",
                "country": "United States",
                "address_1": "215 West Hematite",
                "address_2": "",
                "address_3": "",
                "address_4": "",
                "attention": "",
                "is_physical": "1",
                "location_id": "42625",
                "postal_code": "49849",
                "state_province": "MI",
                "organization_id": ""
            }
        ],
        "locations": [
            {
                "id": "42625",
                "url": "www.co.marquette.mi.us/departments/department_of_veterans_affairs",
                "name": "MARQUETTE COUNTY OFFICE OF VETERANS AFFAIRS",
                "source": "icarol",
                "latitude": "46.4898542",
                "longitude": "87.6707359",
                "source_id": "78181165",
                "description": "Located inside the District Court Building, Ishpeming Michigan",
                "alternate_name": "MARQUETTE COUNTY OFFICE OF VETERANS AFFAIRS",
                "schedule_notes": "Mon-Fri 8am-4pm",
                "transportation": "No public transportation available",
                "organization_id": "42624",
                "organization_name": "MARQUETTE COUNTY OFFICE OF VETERANS AFFAIRS",
                "accessibility_for_disabilities": "Accessible Restroom,Accessible Parking,No Step Entrance,Wheelchair Accessible Service Area"
            }
        ],
        "service_area_served": [
            {
                "id": "225275",
                "name": "Marquette",
                "type": "county",
                "service_id": "",
                "source_service_id": "69241"
            }
        ],
        "tags": []
    },
    {
        "id": 176280,
        "organization_id": 47242,
        "location_id": 47243,
        "source_service_id": 68362,
        "source_id_programAtSite": 87949980,
        "source_id_program": 87949979,
        "source": "icarol",
        "program_id": null,
        "program": "EMPOWER PROGRAM",
        "name": "ENERGY USE AUDITS",
        "alternate_name": "INCOME-BASED,EMPOWER",
        "description": "Provides a no-cost home energy use evaluation to income-eligible households as well as providing energy-saving products such as LED light bulb installation, dehumidifier replacement, refrigerator replacement, insulation and duct sealing.",
        "url": "https://ee.uppco.com/uppco-empower-program/",
        "email": "customerservice@uppco.com",
        "status": 1,
        "interpretation_services": null,
        "application_process": "Call or visit the website to schedule an appointment",
        "wait_time": null,
        "fees": "No fees",
        "schedule_notes": "Mon-Fri 8am-5pm",
        "accreditations": null,
        "licenses": null,
        "eligibility": "- Must be an UPPCO residential customer  - Must have a household income below 200% of the Federal Poverty Level  - Families over the income limit may utilize the Residential Energy Insights program",
        "language": null,
        "payment_accepted": null,
        "required_document": "Call for more information",
        "service_area": "Alger, Baraga, Delta, Houghton, Iron, Keweenaw, Marquette, Menominee, Ontonagon, and Schoolcraft counties",
        "area_served_description": "Alger, Baraga, Delta, Houghton, Iron, Keweenaw, Marquette, Menominee, Ontonagon, and Schoolcraft counties",
        "region": "UPER",
        "contacts": [],
        "regular_schedule": [
            {
                "id": "1246565",
                "weekday": "",
                "opens_at": "",
                "closes_at": "",
                "service_id": "",
                "site_hours": "",
                "service_hours": "Mon-Fri 8am-5pm",
                "organization_id": "",
                "source_service_id": "68362",
                "administrative_hours": "",
                "service_at_location_id": ""
            }
        ],
        "schedule": [],
        "phones": [
            {
                "id": "2184716",
                "type": "Main",
                "number": "9064492222",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "68362",
                "phone_type_hierarchy": "1",
                "service_at_location_id": ""
            }
        ],
        "service_taxonomy": [
            {
                "id": "1347216",
                "category": "",
                "subcategory": "",
                "taxonomy_id": "JD-1500.1800-180",
                "taxonomy_detail": "Energy Use Audits",
                "source_service_id": "68362"
            }
        ],
        "physical_address": [
            {
                "id": "17561",
                "city": "Ishpeming",
                "county": "Marquette",
                "region": "UPER",
                "country": "United States",
                "address_1": "500 North Washington Street",
                "address_2": "",
                "address_3": "",
                "address_4": "",
                "attention": "",
                "is_physical": "1",
                "location_id": "47243",
                "postal_code": "49849",
                "state_province": "MI",
                "organization_id": ""
            }
        ],
        "locations": [
            {
                "id": "47243",
                "url": "www.uppco.com",
                "name": "UPPER PENINSULA POWER COMPANY",
                "source": "icarol",
                "latitude": "46.4940000",
                "longitude": "87.6653700",
                "source_id": "78174624",
                "description": "",
                "alternate_name": "UP POWER, UPPCO",
                "schedule_notes": "Mon-Fri 8am-5pm",
                "transportation": "No public transportation available",
                "organization_id": "47242",
                "organization_name": "UPPER PENINSULA POWER COMPANY",
                "accessibility_for_disabilities": ""
            }
        ],
        "service_area_served": [
            {
                "id": "220070",
                "name": "Alger",
                "type": "county",
                "service_id": "",
                "source_service_id": "68362"
            },
            {
                "id": "220071",
                "name": "Baraga",
                "type": "county",
                "service_id": "",
                "source_service_id": "68362"
            },
            {
                "id": "220072",
                "name": "Delta",
                "type": "county",
                "service_id": "",
                "source_service_id": "68362"
            },
            {
                "id": "220074",
                "name": "Houghton",
                "type": "county",
                "service_id": "",
                "source_service_id": "68362"
            },
            {
                "id": "220075",
                "name": "Iron",
                "type": "county",
                "service_id": "",
                "source_service_id": "68362"
            },
            {
                "id": "220076",
                "name": "Keweenaw",
                "type": "county",
                "service_id": "",
                "source_service_id": "68362"
            },
            {
                "id": "220077",
                "name": "Marquette",
                "type": "county",
                "service_id": "",
                "source_service_id": "68362"
            },
            {
                "id": "220078",
                "name": "Menominee",
                "type": "county",
                "service_id": "",
                "source_service_id": "68362"
            },
            {
                "id": "220079",
                "name": "Ontonagon",
                "type": "county",
                "service_id": "",
                "source_service_id": "68362"
            },
            {
                "id": "220073",
                "name": "Schoolcraft",
                "type": "county",
                "service_id": "",
                "source_service_id": "68362"
            }
        ],
        "tags": []
    },
    {
        "id": 176288,
        "organization_id": 47242,
        "location_id": 47243,
        "source_service_id": 68369,
        "source_id_programAtSite": 87949971,
        "source_id_program": 87949947,
        "source": "icarol",
        "program_id": null,
        "program": null,
        "name": "UTILITY DISCONNECTION PROTECTION  (SENIORS)",
        "alternate_name": "SENIORS 65+",
        "description": "Provides service disconnection protection to eligible senior citizens, age 65 and older, during the heating season of November 1 through March 31 at the customer's documented residence. UPPCO restores service for the customer without payment of the amount due, deposits, reconnection fees, or other charges. At the end of the heating season, accounts will be placed on a payment plan and payment must begin immediately.",
        "url": "https://www.uppco.com/residential/help-with-your-energy-bill/#shutoff-protection",
        "email": "customerservice@uppco.com",
        "status": 1,
        "interpretation_services": null,
        "application_process": "Call for more information",
        "wait_time": null,
        "fees": "No fee for enrollment",
        "schedule_notes": "Mon-Fri 8am-5pm",
        "accreditations": null,
        "licenses": null,
        "eligibility": "Seniors age 65 and older",
        "language": null,
        "payment_accepted": null,
        "required_document": "No documents required",
        "service_area": "Alger, Baraga, Delta, Houghton, Iron, Keweenaw, Marquette, Menominee, Ontonagon, and Schoolcraft counties",
        "area_served_description": "Alger, Baraga, Delta, Houghton, Iron, Keweenaw, Marquette, Menominee, Ontonagon, and Schoolcraft counties",
        "region": "UPER",
        "contacts": [],
        "regular_schedule": [
            {
                "id": "1246601",
                "weekday": "",
                "opens_at": "",
                "closes_at": "",
                "service_id": "",
                "site_hours": "",
                "service_hours": "Mon-Fri 8am-5pm",
                "organization_id": "",
                "source_service_id": "68369",
                "administrative_hours": "",
                "service_at_location_id": ""
            }
        ],
        "schedule": [],
        "phones": [
            {
                "id": "2184728",
                "type": "Main",
                "number": "9064492013",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "68369",
                "phone_type_hierarchy": "1",
                "service_at_location_id": ""
            }
        ],
        "service_taxonomy": [
            {
                "id": "1347269",
                "category": "",
                "subcategory": "",
                "taxonomy_id": "BV-8900.9220",
                "taxonomy_detail": "Utility Disconnection Protection",
                "source_service_id": "68369"
            }
        ],
        "physical_address": [
            {
                "id": "17561",
                "city": "Ishpeming",
                "county": "Marquette",
                "region": "UPER",
                "country": "United States",
                "address_1": "500 North Washington Street",
                "address_2": "",
                "address_3": "",
                "address_4": "",
                "attention": "",
                "is_physical": "1",
                "location_id": "47243",
                "postal_code": "49849",
                "state_province": "MI",
                "organization_id": ""
            }
        ],
        "locations": [
            {
                "id": "47243",
                "url": "www.uppco.com",
                "name": "UPPER PENINSULA POWER COMPANY",
                "source": "icarol",
                "latitude": "46.4940000",
                "longitude": "87.6653700",
                "source_id": "78174624",
                "description": "",
                "alternate_name": "UP POWER, UPPCO",
                "schedule_notes": "Mon-Fri 8am-5pm",
                "transportation": "No public transportation available",
                "organization_id": "47242",
                "organization_name": "UPPER PENINSULA POWER COMPANY",
                "accessibility_for_disabilities": ""
            }
        ],
        "service_area_served": [
            {
                "id": "220172",
                "name": "Alger",
                "type": "county",
                "service_id": "",
                "source_service_id": "68369"
            },
            {
                "id": "220173",
                "name": "Baraga",
                "type": "county",
                "service_id": "",
                "source_service_id": "68369"
            },
            {
                "id": "220174",
                "name": "Delta",
                "type": "county",
                "service_id": "",
                "source_service_id": "68369"
            },
            {
                "id": "220175",
                "name": "Houghton",
                "type": "county",
                "service_id": "",
                "source_service_id": "68369"
            },
            {
                "id": "220176",
                "name": "Iron",
                "type": "county",
                "service_id": "",
                "source_service_id": "68369"
            },
            {
                "id": "220177",
                "name": "Keweenaw",
                "type": "county",
                "service_id": "",
                "source_service_id": "68369"
            },
            {
                "id": "220178",
                "name": "Marquette",
                "type": "county",
                "service_id": "",
                "source_service_id": "68369"
            },
            {
                "id": "220179",
                "name": "Menominee",
                "type": "county",
                "service_id": "",
                "source_service_id": "68369"
            },
            {
                "id": "220180",
                "name": "Ontonagon",
                "type": "county",
                "service_id": "",
                "source_service_id": "68369"
            },
            {
                "id": "220181",
                "name": "Schoolcraft",
                "type": "county",
                "service_id": "",
                "source_service_id": "68369"
            }
        ],
        "tags": []
    },
    {
        "id": 209854,
        "organization_id": 47242,
        "location_id": 47243,
        "source_service_id": 68360,
        "source_id_programAtSite": 88685688,
        "source_id_program": 87949981,
        "source": "icarol",
        "program_id": null,
        "program": "RESIDENTIAL INCOME ASSISTANCE",
        "name": "DISCOUNTED ELECTRIC SERVICE",
        "alternate_name": "INCOME-BASED BILL CREDIT",
        "description": "Provides a $15 monthly bill credit to income-qualified households.",
        "url": "https://www.uppco.com/residential/help-with-your-energy-bill/#assistance-programs",
        "email": "customerservice@uppco.com",
        "status": 1,
        "interpretation_services": null,
        "application_process": "Must complete Residential Income Assistance credit application online or call",
        "wait_time": null,
        "fees": "No fees",
        "schedule_notes": "Mon-Fri 8am-5pm",
        "accreditations": null,
        "licenses": null,
        "eligibility": "Must household income guidelines of 150% of Federal Poverty Level or below",
        "language": null,
        "payment_accepted": null,
        "required_document": "Completed RIA credit application",
        "service_area": "Alger, Baraga, Delta, Houghton, Iron, Keweenaw, Marquette, Menominee, Ontonagon, and Schoolcraft counties",
        "area_served_description": "Alger, Baraga, Delta, Houghton, Iron, Keweenaw, Marquette, Menominee, Ontonagon, and Schoolcraft counties",
        "region": "UPER",
        "contacts": [],
        "regular_schedule": [
            {
                "id": "1247315",
                "weekday": "",
                "opens_at": "",
                "closes_at": "",
                "service_id": "",
                "site_hours": "",
                "service_hours": "Mon-Fri 8am-5pm",
                "organization_id": "",
                "source_service_id": "68360",
                "administrative_hours": "",
                "service_at_location_id": ""
            }
        ],
        "schedule": [],
        "phones": [
            {
                "id": "2185858",
                "type": "Main",
                "number": "9064492013",
                "language": "",
                "extension": "",
                "department": "",
                "service_id": "",
                "description": "",
                "location_id": "",
                "confidential": "0",
                "organization_id": "",
                "source_service_id": "68360",
                "phone_type_hierarchy": "1",
                "service_at_location_id": ""
            }
        ],
        "service_taxonomy": [
            {
                "id": "1347887",
                "category": "",
                "subcategory": "",
                "taxonomy_id": "BV-8900.1700-180",
                "taxonomy_detail": "Discounted Electric Service",
                "source_service_id": "68360"
            }
        ],
        "physical_address": [
            {
                "id": "17561",
                "city": "Ishpeming",
                "county": "Marquette",
                "region": "UPER",
                "country": "United States",
                "address_1": "500 North Washington Street",
                "address_2": "",
                "address_3": "",
                "address_4": "",
                "attention": "",
                "is_physical": "1",
                "location_id": "47243",
                "postal_code": "49849",
                "state_province": "MI",
                "organization_id": ""
            }
        ],
        "locations": [
            {
                "id": "47243",
                "url": "www.uppco.com",
                "name": "UPPER PENINSULA POWER COMPANY",
                "source": "icarol",
                "latitude": "46.4940000",
                "longitude": "87.6653700",
                "source_id": "78174624",
                "description": "",
                "alternate_name": "UP POWER, UPPCO",
                "schedule_notes": "Mon-Fri 8am-5pm",
                "transportation": "No public transportation available",
                "organization_id": "47242",
                "organization_name": "UPPER PENINSULA POWER COMPANY",
                "accessibility_for_disabilities": ""
            }
        ],
        "service_area_served": [
            {
                "id": "221362",
                "name": "Alger",
                "type": "county",
                "service_id": "",
                "source_service_id": "68360"
            },
            {
                "id": "221363",
                "name": "Baraga",
                "type": "county",
                "service_id": "",
                "source_service_id": "68360"
            },
            {
                "id": "221364",
                "name": "Delta",
                "type": "county",
                "service_id": "",
                "source_service_id": "68360"
            },
            {
                "id": "221365",
                "name": "Houghton",
                "type": "county",
                "service_id": "",
                "source_service_id": "68360"
            },
            {
                "id": "221366",
                "name": "Iron",
                "type": "county",
                "service_id": "",
                "source_service_id": "68360"
            },
            {
                "id": "221367",
                "name": "Keweenaw",
                "type": "county",
                "service_id": "",
                "source_service_id": "68360"
            },
            {
                "id": "221368",
                "name": "Marquette",
                "type": "county",
                "service_id": "",
                "source_service_id": "68360"
            },
            {
                "id": "221369",
                "name": "Menominee",
                "type": "county",
                "service_id": "",
                "source_service_id": "68360"
            },
            {
                "id": "221370",
                "name": "Ontonagon",
                "type": "county",
                "service_id": "",
                "source_service_id": "68360"
            },
            {
                "id": "221371",
                "name": "Schoolcraft",
                "type": "county",
                "service_id": "",
                "source_service_id": "68360"
            }
        ],
        "tags": []
    }
]

const mockInruleData = [
    {
        "sessionId": "foo",
        "observations": [],
        "eligibility": {},
        "formData": [
            {
                "question": "Are you currently an UPPCO customer?",
                "type": "multiplechoice",
                "possibleAnswer": [
                    {
                        "text": "Yes"
                    },
                    {
                        "text": "No"
                    }
                ],
                "code": "MI211-30124-4",
                "codeDisplay": "Current UPPCO Customer",
                "valueType": "boolean",
                "rules": ""
            }
        ]
    },
    {
        "sessionId": "foo",
        "observations": [],
        "eligibility": {},
        "formData": [
            {
                "question": "Is the UPPCO account currently in the name of a household member?",
                "type": "multiplechoice",
                "possibleAnswer": [
                    {
                        "text": "Yes"
                    },
                    {
                        "text": "No"
                    }
                ],
                "code": "MI211-40124-5",
                "codeDisplay": "Account In Household Name",
                "valueType": "boolean",
                "rules": ""
            }
        ]
    },
    {
        "sessionId": "foo",
        "observations": [],
        "eligibility": {},
        "formData": [
            {
                "question": "Zip Code/County",
                "type": "text",
                "alreadyAnswered": false,
                "code": "45401-7",
                "processed": false,
                "codeDisplay": "Zip Code County",
                "valueType": "text",
                "rules": ""
            },
            {
                "question": "Household Size",
                "type": "text",
                "code": "86639-2",
                "codeDisplay": "Household Size",
                "valueType": "integer",
                "rules": "required [This field is required] && numeric [Must be a number] && between(1, 99) [Must be between 1 and 99]"
            },
            {
                "question": "Household Monthly Gross Earned Income Total",
                "type": "text",
                "code": "MI211-91570-2",
                "codeDisplay": "Household monthly gross earned income total",
                "valueType": "integer",
                "rules": ""
            }

        ]
    },
    {
        "sessionId": "foo",
        "observations": [],
        "eligibility": {},
        "formData": [
            {
                "question": "Please select if any of the following apply to your household:",
                "type": "label",
                "code": "Label-1"
            },
            {
                "question": "Veteran \\n\\n \"Veteran\" is defined as a person who serviced in the active military, naval, or air service, with any type of discharge other than dishonorable",
                "type": "multiplechoice",
                "possibleAnswer": [
                    {
                        "text": "Yes"
                    },
                    {
                        "text": "No"
                    }
                ],
                "code": "68507-3",
                "codeDisplay": "Household individual veteran",
                "valueType": "boolean",
                "rules": ""
            },
            {
                "question": "Active Duty Military",
                "type": "multiplechoice",
                "possibleAnswer": [
                    {
                        "text": "Yes"
                    },
                    {
                        "text": "No"
                    }
                ],
                "code": "MI211-94382-6",
                "codeDisplay": "Household individual active duty military",
                "valueType": "boolean"
            }
        ]
    },
    {
        "sessionId": "foo",
        "observations": [],
        "eligibility": {
            "recommendedServices": [
                {
                  "pasRecordId": "122044",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "ALGER COUNTY OFFICE OF VETERAN AFFAIRS",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "122049",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "BARAGA COUNTY OFFICE OF VETERAN AFFAIRS",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "122104",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "CHIPPEWA COUNTY OFFICE OF VETERAN AFFAIRS",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "122105",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "DELTA COUNTY OFFICE OF VETERAN SERVICES",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "122108",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "DICKINSON COUNTY VETERAN SERVICE OFFICE",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "122111",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "GOGEBIC COUNTY COUNCIL OF VETERAN AFFAIRS",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "122116",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "HOUGHTON COUNTY OFFICE OF VETERAN AFFAIRS",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "122147",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "IRON COUNTY VETERANS SERVICES OFFICE",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "122205",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "KEWEENAW COUNTY GOVERNMENT",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "122237",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "MENOMINEE COUNTY OFFICE OF VETERAN AFFAIRS",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "158505",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "MARQUETTE COUNTY GOVERNMENT",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "122599",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "SCHOOLCRAFT COUNTY OFFICE OF VETERAN AFFAIRS",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "174289",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "906 WARRIOR RELIEF FUND",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "175320",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "MARQUETTE COUNTY OFFICE OF VETERANS AFFAIRS",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "176276",
                  "programName": "UNDESIGNATED TEMPORARY FINANCIAL ASSISTANCE",
                  "agency": "LUCE COUNTY GOVERNMENT",
                  "taxonomyTerm": "Undesignated Temporary Financial Assistance - Veterans",
                  "taxonomyCode": "NT-8900 * YN-9000"
                },
                {
                  "pasRecordId": "176288",
                  "programName": "UTILITY DISCONNECTION PROTECTION",
                  "agency": "UPPCO",
                  "taxonomyTerm": "Utility Disconnection Protection",
                  "taxonomyCode": "BV-8900.9220"
                },
                {
                  "pasRecordId": "157628",
                  "programName": "UTILITY DISCONNECTION PROTECTION",
                  "agency": "UPPCO",
                  "taxonomyTerm": "Utility Disconnection Protection",
                  "taxonomyCode": "BV-8900.9220"
                },
                {
                  "pasRecordId": "11376",
                  "programName": "WEATHERIZATION PROGRAMS",
                  "agency": "DICKINSON-IRON COMMUNITY SERVICES AGENCY",
                  "taxonomyTerm": "Weatherization Programs",
                  "taxonomyCode": "BH-3000.1800-950"
                },
                {
                  "pasRecordId": "10818",
                  "programName": "WEATHERIZATION PROGRAMS",
                  "agency": "COMMUNITY ACTION ALGER-MARQUETTE",
                  "taxonomyTerm": "Weatherization Programs",
                  "taxonomyCode": "BH-3000.1800-950"
                },
                {
                  "pasRecordId": "16370",
                  "programName": "WEATHERIZATION PROGRAMS",
                  "agency": "GOGEBIC ONTONAGON COMMUNITY ACTION AGENCY",
                  "taxonomyTerm": "Weatherization Programs",
                  "taxonomyCode": "BH-3000.1800-950"
                },
                {
                  "pasRecordId": "16371",
                  "programName": "WEATHERIZATION PROGRAMS",
                  "agency": "GOGEBIC ONTONAGON COMMUNITY ACTION AGENCY",
                  "taxonomyTerm": "Weatherization Programs",
                  "taxonomyCode": "BH-3000.1800-950"
                },
                {
                  "pasRecordId": "16372",
                  "programName": "WEATHERIZATION PROGRAMS",
                  "agency": "GOGEBIC ONTONAGON COMMUNITY ACTION AGENCY",
                  "taxonomyTerm": "Weatherization Programs",
                  "taxonomyCode": "BH-3000.1800-950"
                },
                {
                  "pasRecordId": "11962",
                  "programName": "WEATHERIZATION PROGRAMS",
                  "agency": "CHIPPEWA-LUCE-MACKINAC COMMUNITY ACTION RESOURCE AUTHORITY",
                  "taxonomyTerm": "Weatherization Programs",
                  "taxonomyCode": "BH-3000.1800-950"
                },
                {
                  "pasRecordId": "157630",
                  "programName": "RESIDENTIAL ENERGY/WATER CONSERVATION REBATES",
                  "agency": "UPPCO",
                  "taxonomyTerm": "Residential Energy/Water Conservation Rebates",
                  "taxonomyCode": "BH-3000.1800-700"
                },
                {
                  "pasRecordId": "12169",
                  "programName": "WEATHERIZATION PROGRAMS",
                  "agency": "BARAGA-HOUGHTON-KEWEENAW COMMUNITY ACTION AGENCY",
                  "taxonomyTerm": "Weatherization Programs",
                  "taxonomyCode": "BH-3000.1800-950"
                },
                {
                  "pasRecordId": "121184",
                  "programName": "UTILITY TAX EXEMPTION INFORMATION",
                  "agency": "MICHIGAN DEPARTMENT OF TREASURY",
                  "taxonomyTerm": "Utility Tax Exemption Information",
                  "taxonomyCode": "DT-8700.9000"
                },
                {
                  "pasRecordId": "12169",
                  "programName": "WEATHERIZATION PROGRAMS",
                  "agency": "BARAGA-HOUGHTON-KEWEENAW COMMUNITY ACTION AGENCY",
                  "taxonomyTerm": "Weatherization Programs",
                  "taxonomyCode": "BH-3000.1800-950"
                },
                {
                  "pasRecordId": "176280",
                  "programName": "ENERGY USE AUDITS",
                  "agency": "UPPCO",
                  "taxonomyTerm": "Energy Use Audits",
                  "taxonomyCode": "JD-1500.1800-180"
                },
                {
                  "pasRecordId": "209854",
                  "programName": "ELECTRIC SERVICE PAYMENT ASSISTANCE",
                  "agency": "UPPCO",
                  "taxonomyTerm": "Discounted Electric Service",
                  "taxonomyCode": "BV-8900.1700-180"
                },
                {
                  "pasRecordId": "140054",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "140059",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "15656",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "ALGER COUNTY DEPARTMENT OF HEALTH AND HUMAN SERVICES",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "140186",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "11419",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE (2022-2023)",
                  "agency": "COMMUNITY ACTION ALGER-MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "163943",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE ONLINE APPLICATION",
                  "agency": "SALVATION ARMY MEAP",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "170439",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "157315",
                  "programName": " UTILITY SERVICE PAYMENT ASSISTANCE (2023)",
                  "agency": "HEAT AND WARMTH FUND (THE)",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "140751",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "140756",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "153413",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE (2023-2024)",
                  "agency": "TRUENORTH COMMUNITY SERVICES",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "16404",
                  "programName": "PAYMENT ASSISTANCE FOR GAS, PRESCRIPTION, RENT, AND UTILITIES",
                  "agency": "SAINT VINCENT DE PAUL PRECIOUS BLOOD CONFERENCE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "16414",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "NIFTY THRIFTY",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "140891",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "209882",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "CHIPPEWA-LUCE-MACKINAC COMMUNITY ACTION RESOURCE AUTHORITY",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12407",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12417",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12422",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12427",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12432",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12442",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12447",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12452",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12457",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12462",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12482",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12492",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "158494",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE (2022-2023)",
                  "agency": "CHIPPEWA-LUCE-MACKINAC COMMUNITY ACTION RESOURCE AUTHORITY",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "154800",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE (2022-2023)",
                  "agency": "SUPERIOR WATERSHED PARTNERSHIP",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "158922",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE (2022-2023)",
                  "agency": "SALVATION ARMY - WISCONSIN AND UPPER PENINSULA DIVISIONAL HEADQUARTERS",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "151464",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "DELTA COUNTY DEPARTMENT OF HEALTH AND HUMAN SERVICES",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "151490",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "IRON COUNTY DEPARTMENT OF HEALTH AND HUMAN SERVICES",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "151523",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "KEWEENAW COUNTY DEPARTMENT OF HEALTH AND HUMAN SERVICES",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "151679",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "MARQUETTE COUNTY DEPARTMENT OF HEALTH AND HUMAN SERVICES",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "151684",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "MENOMINEE COUNTY DEPARTMENT OF HEALTH AND HUMAN SERVICES",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "151688",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "ONTONAGON COUNTY DEPARTMENT OF HEALTH AND HUMAN SERVICES",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "151693",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SCHOOLCRAFT COUNTY DEPARTMENT OF HEALTH AND HUMAN SERVICES",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "159135",
                  "programName": "ELECTRIC SERVICE PAYMENT ASSISTANCE",
                  "agency": "SUPERIOR WATERSHED PARTNERSHIP",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "134099",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "BARAGA COUNTY DEPARTMENT OF HEALTH AND HUMAN SERVICES",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "134368",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "HOUGHTON COUNTY DEPARTMENT OF HEALTH AND HUMAN SERVICES",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "174978",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE (EASE 2023-2024)",
                  "agency": "UNITED WAY OF SOUTH CENTRAL MICHIGAN",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "174982",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE (MEAP OTP 2023-2024)",
                  "agency": "UNITED WAY OF SOUTH CENTRAL MICHIGAN",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "158926",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE (2023-2024)",
                  "agency": "SALVATION ARMY - WISCONSIN AND UPPER PENINSULA DIVISIONAL HEADQUARTERS",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "158939",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE (2023-2024)",
                  "agency": "SALVATION ARMY - WISCONSIN AND UPPER PENINSULA DIVISIONAL HEADQUARTERS",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "158933",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE (2023-2024)",
                  "agency": "SALVATION ARMY - WISCONSIN AND UPPER PENINSULA DIVISIONAL HEADQUARTERS",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "158918",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE (2023-2024)",
                  "agency": "SALVATION ARMY - WISCONSIN AND UPPER PENINSULA DIVISIONAL HEADQUARTERS",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "153442",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "209977",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                },
                {
                  "pasRecordId": "12467",
                  "programName": "UTILITY SERVICE PAYMENT ASSISTANCE",
                  "agency": "SAINT VINCENT DE PAUL SOCIETY DIOCESAN COUNCIL OF MARQUETTE",
                  "taxonomyTerm": "Electric Service Payment Assistance",
                  "taxonomyCode": "BV-8900.9300-180"
                }
              ] 
        },
        "formData": [
            {
                "question": "Active Duty Military",
                "type": "multiplechoice",
                "alreadyAnswered": true,
                "possibleAnswer": [
                    {
                        "text": "Yes"
                    },
                    {
                        "text": "No"
                    }
                ],
                "code": "MI211-94382-6",
                "processed": true,
                "codeDisplay": "Household individual active duty military",
                "valueType": "boolean"
            }
        ],
        "tags": []
    },
    {
        "sessionId": "foo",
        "observations": [],
        "eligibility": {
            "note": "<span style=“font-size: 50px;“> Test test test </span>"
        },
        "formData": [
            {
                "question": "Active Duty Military",
                "type": "multiplechoice",
                "alreadyAnswered": true,
                "possibleAnswer": [
                    {
                        "text": "Yes"
                    },
                    {
                        "text": "No"
                    }
                ],
                "code": "MI211-94382-6",
                "processed": true,
                "codeDisplay": "Household individual active duty military",
                "valueType": "boolean"
            }
        ]
    }
]

module.exports = {
    mockServiceCompleteReferralData,
    mockInruleData
}